import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border bg-card">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center gap-4">
            <Link to="/">
              <Button variant="ghost" size="sm">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to Home
              </Button>
            </Link>
            <h1 className="text-xl font-bold">Terms of Service</h1>
          </div>
        </div>
      </header>

      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <Card>
          <CardHeader>
            <CardTitle className="text-2xl">Terms of Service</CardTitle>
            <p className="text-muted-foreground">
              Last updated: January 15, 2025
            </p>
          </CardHeader>
          <CardContent className="prose prose-sm max-w-none">
            <h2>Acceptance of Terms</h2>
            <p>
              By accessing and using Kente Weave Design, you accept and agree to
              be bound by the terms and provision of this agreement. If you do
              not agree to abide by the above, please do not use this service.
            </p>

            <h2>Use License</h2>
            <p>
              Permission is granted to temporarily download one copy of the
              materials on Kente Weave Design's website for personal,
              non-commercial transitory viewing only. This is the grant of a
              license, not a transfer of title.
            </p>

            <h2>User Accounts</h2>
            <p>
              When you create an account with us, you must provide information
              that is accurate, complete, and current at all times. You are
              responsible for safeguarding the password and for all activities
              that occur under your account.
            </p>

            <h2>Prohibited Uses</h2>
            <p>
              You may not use our service for any unlawful purpose or to solicit
              others to perform or participate in any unlawful acts. You may not
              violate any local, state, national, or international law.
            </p>

            <h2>Intellectual Property</h2>
            <p>
              The service and its original content, features, and functionality
              are and will remain the exclusive property of Kente Weave Design
              and its licensors. The service is protected by copyright,
              trademark, and other laws.
            </p>

            <h2>Contact Information</h2>
            <p>
              If you have any questions about these Terms of Service, please
              contact us at{" "}
              <a
                href="mailto:info@orctatech.com"
                className="text-primary hover:underline"
              >
                info@orctatech.com
              </a>
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TermsOfService;
